<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="1.2"
      y1="14.8"
      x2="16.8"
      y2="14.8"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="1.2"
      y1="8.8"
      x2="16.8"
      y2="8.8"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="1.2"
      y1="2.8"
      x2="16.8"
      y2="2.8"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
  export default {
    name: 'HamburgerIcon',
  };
</script>

